import axios from 'axios';

const baseDomain = process.env.VUE_APP_BACKEND_URL;
//const baseDomain = 'http://localhost:8000';
const baseUrl = `${baseDomain}/api`;
const axiosInstance = axios.create({
    baseURL: baseUrl
});

// Add a request interceptor
axiosInstance.interceptors.request.use(function (config) {
    // eslint-disable-next-line no-undef
    sso.appendHeadersToRequest(function (key, value) {
        config.headers[key] = value;
    });
    const hash = location.hash.substring(1);
    let splitted = hash.split('?');
    if (splitted.length > 1) {
        const urlParams = new URLSearchParams('?' + splitted[1]);
        let key = urlParams.get('key');
        if (key) {
            config.params = {...config.params, key: key};
        }
    }
    return config;
});

axiosInstance.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    if (response.data && typeof response.data.status !== 'undefined' && response.data.status === 'redirect') {
        location.href = response.data.url;
    } else {
        return response;
    }
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    let returnError = error;
    if (Object.prototype.hasOwnProperty.call(error.response, 'data')) {
        let errorMessage = error.response.data.message ?? error.response.data;
        if (Object.prototype.hasOwnProperty.call(error.response.data, 'errors')) {
            for (let key in error.response.data.errors) {
                if (Object.prototype.hasOwnProperty.call(error.response.data.errors, key)) {
                    errorMessage += '\n' + key + ': ';
                    for (let i = 0; i < error.response.data.errors[key].length; i++) {
                        errorMessage += error.response.data.errors[key][i] + '. ';
                    }
                }
            }
        }
        if(typeof errorMessage === 'object' && errorMessage !== null){
            returnError = new Error(JSON.stringify(errorMessage));
        } else{
            returnError = new Error(errorMessage);
        }

    }
    return Promise.reject(returnError);
});

export default axiosInstance;